import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { NavigatorContext } from './Navigator.Context';
import NavigatorRouter from './NavigatorRouter';

function Navigator(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Navigator'),
      _useContextSystem$ani = _useContextSystem.animationDuration,
      animationDuration = _useContextSystem$ani === void 0 ? 300 : _useContextSystem$ani,
      children = _useContextSystem.children,
      initialPath = _useContextSystem.initialPath;

  return /*#__PURE__*/React.createElement(NavigatorContext.Provider, {
    ref: forwardedRef,
    value: {
      animationDuration: animationDuration
    }
  }, /*#__PURE__*/React.createElement(NavigatorRouter, {
    initialPath: initialPath
  }, children));
}

export default contextConnect(Navigator, 'Navigator');